import { axiosDelete, axiosGet, axiosPatch, axiosPost } from "../axios/axiosWithAuth";
import { ApiRoutes } from "../constants";
import { INGOForm } from "../modals/add-edit-ngo-modal/const";
import { OrganizationInputTypes } from "../pages/shared/CreateEditOrganization/const";
import { BasePayload, ExtOrganizationType } from "../types";
import { throwError } from "../utils/error"

interface GetOrganizationsPayload extends BasePayload {
    search: string;
}
export const getOrganizations = async (payload: GetOrganizationsPayload) => {
    try {
        const res = await axiosGet(`${ApiRoutes.ADMIN.GET_ORGANIZATIONS}?search=${payload.search}&page=${payload.page}&limit=${payload.limit}`);
        return res.data;
    } catch (error) {
        throwError(error);
    }
}

interface UpdateOrgPayload extends Partial<ExtOrganizationType> { }

export const updateOrganizationByAdmin = async (organizationId: string, payload: UpdateOrgPayload) => {
    try {
        const res = await axiosPatch(ApiRoutes.ADMIN.UPDATE_ORGANIZATION(organizationId), payload);
        return res.data;
    } catch (error) {
        throwError(error);
    }
}

interface CreateOrgByAdminPayload extends OrganizationInputTypes { }

export const createOrganizationByAdmin = async (payload: CreateOrgByAdminPayload) => {
    try {
        const res = await axiosPost(ApiRoutes.ADMIN.CREATE_ORGANIZATION, payload);
        return res.data;
    } catch (error) {
        throwError(error);
    }
}


export const getOrganizationByAdmin = async (organizationId: string) => {
    try {
        const res = await axiosGet(ApiRoutes.ADMIN.GET_ORGANIZATION(organizationId));
        return res.data;
    } catch (error) {
        throwError(error);
    }
}

interface CreateEditCityPayload {
    city: string;
    state?: string;
    country?: string;
}
export const createAdminCity = async (payload: CreateEditCityPayload) => {
    try {
        const res = await axiosPost(ApiRoutes.ADMIN.CREATE_CITY, payload);
        return res.data;
    } catch (error) {
        throwError(error);
    }
}

export const updateAdminCity = async (cityId: string, payload: CreateEditCityPayload) => {
    try {
        const res = await axiosPatch(ApiRoutes.ADMIN.UPDATE_CITY(cityId), payload);
        return res.data;
    } catch (error) {
        throwError(error);
    }
}

export const deleteAdminCity = async (cityId: string) => {
    try {
        const res = await axiosDelete(ApiRoutes.ADMIN.DELETE_CITY(cityId));
        return res.data;
    } catch (error) {
        throwError(error);
    }
}

interface GetAdminCitiesPayload extends BasePayload {
}

export const getAdminCities = async (payload?: GetAdminCitiesPayload) => {
    try {
        const res = await axiosGet(`${ApiRoutes.ADMIN.GET_CITIES}?search=${payload?.search}&page=${payload?.page}&limit=${payload?.limit}`);
        return res.data;
    } catch (error) {
        throwError(error);
    }
}

/* ADMIN NGO SERVICES */
interface GetAdminNGOSPayload extends BasePayload { }
export const getAdminNGOS = async (payload?: GetAdminNGOSPayload) => {
    try {
        const res = await axiosGet(`${ApiRoutes.ADMIN.NGO.LIST}?search=${payload?.search}&page=${payload?.page}&limit=${payload?.limit}`);
        return res.data;
    } catch (error) {
        throwError(error);
    }
}

interface CreateAdminNGOPayload extends INGOForm { }
export const createAdminNGO = async (payload: CreateAdminNGOPayload) => {
    try {
        const res = await axiosPost(ApiRoutes.ADMIN.NGO.CREATE, payload);
        return res.data;
    } catch (error) {
        throwError(error);
    }
}
interface UpdateAdminNGOPayload extends Partial<INGOForm> { }

export const updateAdminNGO = async (ngoId: string, payload: UpdateAdminNGOPayload) => {
    try {
        const res = await axiosPatch(ApiRoutes.ADMIN.NGO.UPDATE(ngoId), payload);
        return res.data;
    } catch (error) {
        throwError(error);
    }
}
export const deleteAdminNGO = async (ngoId: string) => {
    try {
        const res = await axiosDelete(ApiRoutes.ADMIN.NGO.DELETE(ngoId));
        return res.data;
    } catch (error) {
        throwError(error);
    }
}